/**
 * Portfolio PDF API — Chunk 94: Portfolio Performance PDF Export
 *
 * downloadPortfolioPDF(userId) — fetches the PDF as a blob and triggers a
 * browser download named "portfolio-report-YYYY-MM-DD.pdf".
 */

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

/**
 * Download the portfolio performance PDF for the given user.
 * Triggers a browser file download automatically.
 */
export async function downloadPortfolioPDF(userId: string): Promise<void> {
  const token = localStorage.getItem('accessToken') || '';

  const response = await fetch(
    `${API_BASE_URL}/analytics/portfolio-pdf/${encodeURIComponent(userId)}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/pdf',
      },
    },
  );

  if (!response.ok) {
    let message = `PDF generation failed (HTTP ${response.status})`;
    try {
      const body = (await response.json()) as { error?: string };
      if (body.error) message = body.error;
    } catch {
      // ignore parse errors
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  const dateStr = new Date().toISOString().slice(0, 10);
  a.download = `portfolio-report-${dateStr}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
